import React from 'react';
import { Button } from 'react-bootstrap';
import { DeleteIcon } from 'components/Icons';
import { useTranslation } from 'react-i18next';

/**
 *  @PROPS
 *  ref: object//Forwarding refs to DOM components .
 *  onChange: function //Callback function to run on change. Accepts parameter event.
 *  uploadType: string//HTML5 input type. Defaults to file.
 *  customClass: object//React type styles to apply to the internal input element.
 *  uploadLabel: string//Label text to display inside input.
 *  UploadIcon: image//image to display inside input.
 *  attachment: array//media files array.
 *  handleFileDelete:function //Callback function to delete media files.Accepts parameter url.
 *  mediaTypes:strings//HTML5 input accept types.
 */

const GenericUpload = React.forwardRef(
  (
    { uploadType = 'file', customClass, onChange, attachment, handleFileDelete, uploadLabel, UploadIcon, mediaTypes },
    ref
  ) => {
    const { t } = useTranslation();
    return (
      <>
        <div
          className="input-wrapper"
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
        >
          <div style={{ display: 'flex' }}>
            <label className="form-label" htmlFor="email">
              {t(uploadLabel)}: {<span><span style={{ color: attachment && attachment.length > 0 ? '#fff' : '' }}>{attachment.length ? attachment.length : '0'}</span>/10</span>}
            </label>
            <input
              type={uploadType}
              className={customClass}
              onChange={e => onChange(e)}
              style={{ display: 'none' }}
              ref={ref}
              accept={mediaTypes}
            />
          </div>
          <div style={{ display: 'flex' }}>
            <Button
              type="button"
              onClick={() => {
                ref.current.click();
              }}
              className="main-button"
            >
              <UploadIcon />
            </Button>
          </div>
        </div>
        <div className="attachmant-wrapper">
          {attachment.map((file, index) => {
            return (
              <div
                className="d-flex align-items-end justify-content-end "
                style={{ marginRight: 18, marginBottom: 16 }}
                key={`image_${index}`}
              >
                <img src={file.url} width={64} height={64} alt="attachemnts" style={{ borderRadius: 8, objectFit: "cover", objectPosition: "center"}} />
                <div style={{ position: 'relative' }}>
                  <button
                    type = "button"
                    className="delete-button"
                    onClick={() => handleFileDelete(file.url)}
                  >
                    <DeleteIcon />
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </>
    );
  }
);

export default GenericUpload;
